// John Eldhose 20190515

const setLoginPage = (page) => {
  document.cookie = 'LoginPage=' + window.btoa(JSON.stringify(page));
}
const loadLoginPage = () => {
  const cookies = document.cookie.split(';');
  var arr, page = null;
  for(var i = 0; i < cookies.length; i++) {
    arr = cookies[i].trim().split('=');
    if(arr[0] === 'LoginPage' && arr[1] !== '') {
      page = JSON.parse(window.atob(arr[1]));
      break;
    }
  }
  if(page !== null && (typeof page.url === 'undefined' || page.url === ''))
    page = null;
  return page;
}
const resetLoginPage = () => {
  document.cookie = 'LoginPage=;expires=0';
}

export { setLoginPage, loadLoginPage, resetLoginPage };



// WEBPACK FOOTER //
// ./src/components/lib/LoginPage.js